export default __webpack_public_path__ + "static/media/close-circled.6cebd649.svg";